import React from 'react';
import Seat from '../../../components/Seat';
import WagonDoor from '../../../components/WagonDoor';
import WagonToilet from '../../../components/WagonToilet';
import useTranslation from '../../../../hooks/translation/useTranslation';
import { useBooking } from '../../../../contexts/ticketBookingContext/TicketBookingContext';
import filterAvailableSeats from '../../../../../utils/functions/booking/filterAvailableSeats';
import CoupeReserve from '../../../components/CoupeReserve';
import { useWagonContext } from '../../../../contexts/wagonContext/wagonContext';

function FirstFloor({
  seats, chosenSeats, setChosenSeats, wagonNumber, unReserveSeat, reserveSeat,
}) {
  const { trans } = useTranslation();
  const { direction } = useWagonContext();
  const { bookingData } = useBooking();

  return (
    <div>
      <div className="wagon">
        <div className="wagon-floor">
          <h2>I</h2>
        </div>
        <div
          className="seats-row left"
          style={{ width: '755.3px', marginLeft: '40px' }}
        >
          <WagonDoor />
          <WagonToilet />
          {
            [37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54].map(
              (seat, index) => (
                index % 2
                  ? (
                    <div className="seat-column " key={seat}>
                      <Seat
                        seat={seats?.[seat]}
                        chosenSeats={chosenSeats}
                        setChosenSeats={setChosenSeats}
                        wagonNumber={wagonNumber}
                        reserveSeat={reserveSeat}
                        noDirection
                        unReserveSeat={unReserveSeat}
                        seatPropertyIcon={(
                          <div className="seat-property ml-[2px] mt-[-2px]">
                            <img
                              src="/wagon-icons/seatArrow.webp"
                              width={22}
                              height={22}
                              alt="arrow"
                              className="rotate-180"
                            />
                          </div>
                              )}
                        bottom
                        hidePrice
                        seatTooltipExtraText={(
                          <p className="m-0">
                            {trans('upper')}
                          </p>
)}
                      />
                    </div>
                  )
                  : (
                    <div className="seat-column" key={seat}>
                      <Seat
                        seat={seats?.[seat]}
                        chosenSeats={chosenSeats}
                        setChosenSeats={setChosenSeats}
                        wagonNumber={wagonNumber}
                        reserveSeat={reserveSeat}
                        unReserveSeat={unReserveSeat}
                        bottom
                        noDirection
                        seatPropertyIcon={(
                          <div className="seat-property ml-[2px] mt-[-2px]">
                            <img
                              src="/wagon-icons/seatArrow.webp"
                              width={22}
                              height={22}
                              alt="arrow"
                            />
                          </div>
                              )}
                        seatTooltipExtraText={(
                          <p className="m-0">
                            {trans('lower')}
                          </p>
                        )}
                        hidePrice
                      />
                    </div>
                  )
              ),
            )
          }
          <WagonDoor />
        </div>
        <div
          className="seats-row bottom left"
          style={{ width: '755.3px', marginLeft: '94px' }}
        >
          <WagonToilet />
          {
            [
              [36, 35, 34, 33],
              [32, 31, 30, 29],
              [28, 27, 26, 25],
              [24, 23, 22, 21],
              [20, 19, 18, 17],
              [16, 15, 14, 13],
              [12, 11, 10, 9],
              [8, 7, 6, 5],
              [4, 3, 2, 1],
            ].map((seatsPair) => {
              const availableSeats = filterAvailableSeats({
                seatsToReserve: seatsPair,
                direction,
                seats,
                bookingData,
                chosenSeats,
                reserveSeat,
                unReserveSeat,
                wagonNumber,
              });

              return (
                <React.Fragment key={seatsPair[0]}>
                  <div className="seat-column relative">
                    <CoupeReserve
                      reserveSeat={reserveSeat}
                      unReserveSeat={unReserveSeat}
                      wagonNumber={wagonNumber}
                      availableSeats={availableSeats}
                      seats={seats}
                    />
                    <Seat
                      seat={seats?.[seatsPair[0]]}
                      chosenSeats={chosenSeats}
                      setChosenSeats={setChosenSeats}
                      wagonNumber={wagonNumber}
                      reserveSeat={reserveSeat}
                      unReserveSeat={unReserveSeat}
                      noDirection
                      seatPropertyIcon={(
                        <div className="seat-property ml-[2px] mt-[-2px]">
                          <img
                            src="/wagon-icons/seatArrow.webp"
                            width={22}
                            height={22}
                            alt="arrow"
                            className="rotate-180"
                          />
                        </div>
                          )}
                      seatTooltipExtraText={(
                        <p className="m-0">
                          {trans('upper')}
                        </p>
                          )}
                      hidePrice
                    />
                    <Seat
                      seat={seats?.[seatsPair[1]]}
                      chosenSeats={chosenSeats}
                      setChosenSeats={setChosenSeats}
                      wagonNumber={wagonNumber}
                      reserveSeat={reserveSeat}
                      unReserveSeat={unReserveSeat}
                      noDirection
                      seatPropertyIcon={(
                        <div className="seat-property ml-[2px] mt-[-2px]">
                          <img
                            src="/wagon-icons/seatArrow.webp"
                            width={22}
                            height={22}
                            alt="arrow"
                          />
                        </div>
                          )}
                      seatTooltipExtraText={(
                        <p className="m-0">
                          {trans('lower')}
                        </p>
                          )}
                      hidePrice
                      bottom
                    />
                  </div>
                  <div className="relative">
                    <div className="seat-column reversed">
                      <Seat
                        seat={seats?.[seatsPair[3]]}
                        chosenSeats={chosenSeats}
                        setChosenSeats={setChosenSeats}
                        wagonNumber={wagonNumber}
                        reserveSeat={reserveSeat}
                        noDirection
                        unReserveSeat={unReserveSeat}
                        seatPropertyIcon={(
                          <div className="seat-property ml-[-2px] mt-[1px]">
                            <img
                              src="/wagon-icons/seatArrow.webp"
                              width={22}
                              height={22}
                              alt="arrow"
                            />
                          </div>
                            )}
                        seatTooltipExtraText={(
                          <p className="m-0">
                            {trans('lower')}
                          </p>
                            )}
                        hidePrice
                      />
                      <Seat
                        seat={seats?.[seatsPair[2]]}
                        chosenSeats={chosenSeats}
                        setChosenSeats={setChosenSeats}
                        noDirection
                        wagonNumber={wagonNumber}
                        reserveSeat={reserveSeat}
                        unReserveSeat={unReserveSeat}
                        bottom
                        seatPropertyIcon={(
                          <div className="seat-property ml-[-2px] mt-[-4px]">
                            <img
                              src="/wagon-icons/seatArrow.webp"
                              width={22}
                              height={22}
                              alt="arrow"
                              className="rotate-180"
                            />
                          </div>
                            )}
                        seatTooltipExtraText={(
                          <p className="m-0">
                            {trans('upper')}
                          </p>
                            )}
                        hidePrice
                      />
                    </div>

                  </div>

                </React.Fragment>
              );
            })
          }
          <WagonDoor />
        </div>
      </div>
    </div>
  );
}

export default FirstFloor;
